import React from 'react'
import { IconWrapper } from '../IconWrapper'
import type { IconWrapperProps } from '../IconWrapper'

export const EcommDiscountIcon = React.forwardRef<SVGSVGElement, IconWrapperProps>(
  (props, forwardedRef) => {
    return (
      <IconWrapper {...props}>
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
          ref={forwardedRef}
        >
          <path
            d="M9 8.75C8.86193 8.75 8.75 8.86193 8.75 9C8.75 9.13807 8.86193 9.25 9 9.25C9.13807 9.25 9.25 9.13807 9.25 9C9.25 8.86193 9.13807 8.75 9 8.75ZM7.25 9C7.25 8.0335 8.0335 7.25 9 7.25C9.9665 7.25 10.75 8.0335 10.75 9C10.75 9.9665 9.9665 10.75 9 10.75C8.0335 10.75 7.25 9.9665 7.25 9ZM16.5303 7.46967C16.8232 7.76256 16.8232 8.23744 16.5303 8.53033L8.53033 16.5303C8.23744 16.8232 7.76256 16.8232 7.46967 16.5303C7.17678 16.2374 7.17678 15.7626 7.46967 15.4697L15.4697 7.46967C15.7626 7.17678 16.2374 7.17678 16.5303 7.46967ZM15 14.5784C14.8619 14.5784 14.75 14.6903 14.75 14.8284C14.75 14.9664 14.8619 15.0784 15 15.0784C15.1381 15.0784 15.25 14.9664 15.25 14.8284C15.25 14.6903 15.1381 14.5784 15 14.5784ZM13.25 14.8284C13.25 13.8619 14.0335 13.0784 15 13.0784C15.9665 13.0784 16.75 13.8619 16.75 14.8284C16.75 15.7949 15.9665 16.5784 15 16.5784C14.0335 16.5784 13.25 15.7949 13.25 14.8284Z"
            fill="#222"
            fillRule="evenodd"
            clipRule="evenodd"
          />
          <path
            d="M12 2.75C6.89137 2.75 2.75 6.89137 2.75 12C2.75 17.1086 6.89137 21.25 12 21.25C17.1086 21.25 21.25 17.1086 21.25 12C21.25 6.89137 17.1086 2.75 12 2.75ZM1.25 12C1.25 6.06294 6.06294 1.25 12 1.25C17.9371 1.25 22.75 6.06294 22.75 12C22.75 17.9371 17.9371 22.75 12 22.75C6.06294 22.75 1.25 17.9371 1.25 12Z"
            fill="#222"
            fillRule="evenodd"
            clipRule="evenodd"
          />
        </svg>
      </IconWrapper>
    )
  },
)
